var map = {
	"./": 177,
	"./App": 266,
	"./App.css": 350,
	"./App.js": 266,
	"./Confirm": 353,
	"./Confirm.js": 353,
	"./Loading": 199,
	"./Loading.js": 199,
	"./Routes": 193,
	"./Routes.js": 193,
	"./auth": 28,
	"./auth/": 28,
	"./auth/PrivateRoute": 46,
	"./auth/PrivateRoute.js": 46,
	"./auth/index": 28,
	"./auth/index.js": 28,
	"./business": 354,
	"./business.json": 354,
	"./components/DeletePopup/DeletePopup": 42,
	"./components/DeletePopup/DeletePopup.css": 584,
	"./components/DeletePopup/DeletePopup.js": 42,
	"./components/DrawerContent/DrawerContent": 195,
	"./components/DrawerContent/DrawerContent.css": 339,
	"./components/DrawerContent/DrawerContent.js": 195,
	"./components/Form/Form": 359,
	"./components/Form/Form.js": 359,
	"./components/Form/Form3": 360,
	"./components/Form/Form3.js": 360,
	"./components/HomePage/StoreItem/StoreItem": 201,
	"./components/HomePage/StoreItem/StoreItem.css": 361,
	"./components/HomePage/StoreItem/StoreItem.js": 201,
	"./components/HomePage/StoreItem/abc": 365,
	"./components/HomePage/StoreItem/abc.json": 365,
	"./components/HomePage/Stores/Stores": 366,
	"./components/HomePage/Stores/Stores.css": 367,
	"./components/HomePage/Stores/Stores.js": 366,
	"./components/ImageDropzone/ImageDropzone": 203,
	"./components/ImageDropzone/ImageDropzone.css": 368,
	"./components/ImageDropzone/ImageDropzone.js": 203,
	"./components/ImgDropzone/ImgDropzone": 131,
	"./components/ImgDropzone/ImgDropzone.css": 364,
	"./components/ImgDropzone/ImgDropzone.js": 131,
	"./components/Layout/Footer/Footer": 196,
	"./components/Layout/Footer/Footer.css": 340,
	"./components/Layout/Footer/Footer.js": 196,
	"./components/Layout/Layout": 34,
	"./components/Layout/Layout.css": 341,
	"./components/Layout/Layout.js": 34,
	"./components/Layout/Navbar/CartIcon/CartIcon": 369,
	"./components/Layout/Navbar/CartIcon/CartIcon.css": 370,
	"./components/Layout/Navbar/CartIcon/CartIcon.js": 369,
	"./components/Layout/Navbar/Language/Language": 371,
	"./components/Layout/Navbar/Language/Language.css": 372,
	"./components/Layout/Navbar/Language/Language.js": 371,
	"./components/Layout/Navbar/Navbar": 194,
	"./components/Layout/Navbar/Navbar.css": 337,
	"./components/Layout/Navbar/Navbar.js": 194,
	"./components/Layout/Navbar/NavbarButtons/NavbarButtons": 128,
	"./components/Layout/Navbar/NavbarButtons/NavbarButtons.css": 338,
	"./components/Layout/Navbar/NavbarButtons/NavbarButtons.js": 128,
	"./components/MultiImages/MultiImages": 105,
	"./components/MultiImages/MultiImages.css": 373,
	"./components/MultiImages/MultiImages.js": 105,
	"./components/MultiImages/VarMultiImage": 205,
	"./components/MultiImages/VarMultiImage.css": 376,
	"./components/MultiImages/VarMultiImage.js": 205,
	"./components/NewProductPopup/NewProductPopup": 206,
	"./components/NewProductPopup/NewProductPopup.css": 377,
	"./components/NewProductPopup/NewProductPopup.js": 206,
	"./components/Rating/Rating": 202,
	"./components/Rating/Rating.css": 362,
	"./components/Rating/Rating.js": 202,
	"./components/SearchBar/SearchBar": 207,
	"./components/SearchBar/SearchBar.css": 378,
	"./components/SearchBar/SearchBar.js": 207,
	"./components/Signin/Signin": 138,
	"./components/Signin/Signin.css": 336,
	"./components/Signin/Signin.js": 138,
	"./components/Signup/Signup": 379,
	"./components/Signup/Signup.css": 380,
	"./components/Signup/Signup.js": 379,
	"./components/SignupBusiness/SignupBusiness": 129,
	"./components/SignupBusiness/SignupBusiness.css": 352,
	"./components/SignupBusiness/SignupBusiness.js": 129,
	"./components/StoreAdminPage/StoreAdminPage": 381,
	"./components/StoreAdminPage/StoreAdminPage.css": 382,
	"./components/StoreAdminPage/StoreAdminPage.js": 381,
	"./components/StoreCard/StoreCard": 208,
	"./components/StoreCard/StoreCard.css": 594,
	"./components/StoreCard/StoreCard.js": 208,
	"./components/StoreImages/StoreImages": 130,
	"./components/StoreImages/StoreImages.css": 363,
	"./components/StoreImages/StoreImages.js": 130,
	"./components/StorePage/CategoryButtons/CategoryButtons": 209,
	"./components/StorePage/CategoryButtons/CategoryButtons.css": 383,
	"./components/StorePage/CategoryButtons/CategoryButtons.js": 209,
	"./components/StorePage/ImagePopup/ImagePopup": 210,
	"./components/StorePage/ImagePopup/ImagePopup.css": 384,
	"./components/StorePage/ImagePopup/ImagePopup.js": 210,
	"./components/StorePage/Popup/Popup": 385,
	"./components/StorePage/Popup/Popup.css": 386,
	"./components/StorePage/Popup/Popup.js": 385,
	"./components/StorePage/Product/Product": 387,
	"./components/StorePage/Product/Product.css": 388,
	"./components/StorePage/Product/Product.js": 387,
	"./components/StorePage/Product/ProductCard/ProductCard": 211,
	"./components/StorePage/Product/ProductCard/ProductCard.css": 389,
	"./components/StorePage/Product/ProductCard/ProductCard.js": 211,
	"./components/StorePage/Product/Table/NewTableVar": 212,
	"./components/StorePage/Product/Table/NewTableVar.js": 212,
	"./components/StorePage/Product/Table/ProductTable": 213,
	"./components/StorePage/Product/Table/ProductTable.css": 148,
	"./components/StorePage/Product/Table/ProductTable.js": 213,
	"./components/StorePage/Product/Table/TelmedNewTableVar": 132,
	"./components/StorePage/Product/Table/TelmedNewTableVar.js": 132,
	"./components/StorePage/Product/Table/VarTable1": 390,
	"./components/StorePage/Product/Table/VarTable1.js": 390,
	"./components/StorePage/Product/Table/WarehouseTable": 106,
	"./components/StorePage/Product/Table/WarehouseTable.js": 106,
	"./components/StorePage/Product/Table/filters": 89,
	"./components/StorePage/Product/Table/filters.js": 89,
	"./components/StorePage/Product/Table/makeData": 391,
	"./components/StorePage/Product/Table/makeData.js": 391,
	"./components/StorePage/StoreInfo/StoreInfo": 214,
	"./components/StorePage/StoreInfo/StoreInfo.css": 443,
	"./components/StorePage/StoreInfo/StoreInfo.js": 214,
	"./components/StorePage/StorePage": 215,
	"./components/StorePage/StorePage.css": 446,
	"./components/StorePage/StorePage.js": 215,
	"./components/StorePage/StoreSettings/StoreSettings": 216,
	"./components/StorePage/StoreSettings/StoreSettings.css": 444,
	"./components/StorePage/StoreSettings/StoreSettings.js": 216,
	"./components/StorePage/handleInc": 448,
	"./components/StorePage/handleInc.js": 448,
	"./components/Stores/Stores": 218,
	"./components/Stores/Stores.css": 696,
	"./components/Stores/Stores.js": 218,
	"./components/SuccessMessage/SuccessMessage": 66,
	"./components/SuccessMessage/SuccessMessage.css": 447,
	"./components/SuccessMessage/SuccessMessage.js": 66,
	"./components/Tags/Tags": 134,
	"./components/Tags/Tags.css": 450,
	"./components/Tags/Tags.js": 134,
	"./components/VerticalTabs/VerticalTabs": 451,
	"./components/VerticalTabs/VerticalTabs.js": 451,
	"./components/WarehousePopup/Warehouse": 217,
	"./components/WarehousePopup/Warehouse.js": 217,
	"./components/WarehousePopup/WarehousePopup": 133,
	"./components/WarehousePopup/WarehousePopup.css": 445,
	"./components/WarehousePopup/WarehousePopup.js": 133,
	"./config": 7,
	"./config.js": 7,
	"./functions/getImage": 32,
	"./functions/getImage.js": 32,
	"./functions/is_auth": 219,
	"./functions/is_auth.js": 219,
	"./getCookie": 200,
	"./getCookie.js": 200,
	"./img/Pljeskavica.png": 816,
	"./img/background.png": 817,
	"./img/background2.png": 818,
	"./img/background3.png": 819,
	"./img/checkmark.gif": 311,
	"./img/desktop.PNG": 820,
	"./img/edit.png": 821,
	"./img/false.png": 163,
	"./img/fish.jpg": 822,
	"./img/fish_back.jpg": 823,
	"./img/flags/albania.png": 824,
	"./img/flags/bosnia.png": 825,
	"./img/flags/kosovo.png": 826,
	"./img/flags/turkey.png": 827,
	"./img/flags/united-kingdom.png": 828,
	"./img/fresh1.png": 829,
	"./img/fresh2.png": 830,
	"./img/fresh_back.jpg": 831,
	"./img/hamburger.png": 832,
	"./img/icecek1.png": 833,
	"./img/icecekler.png": 834,
	"./img/ichef.jpg": 835,
	"./img/ichef_back.jpg": 836,
	"./img/kebap.png": 837,
	"./img/kebap_back.jpg": 838,
	"./img/kofte1.png": 839,
	"./img/kofte2.png": 840,
	"./img/kofte3.png": 841,
	"./img/loading.gif": 310,
	"./img/logo-nav.png": 842,
	"./img/logo-si.png": 309,
	"./img/logo.png": 843,
	"./img/logo2.png": 844,
	"./img/logo3.png": 845,
	"./img/malina.png": 846,
	"./img/malina3.png": 847,
	"./img/mango.png": 848,
	"./img/noImage.png": 238,
	"./img/no_image.jpg": 849,
	"./img/phone.png": 850,
	"./img/pide.png": 851,
	"./img/pide_back.jpg": 852,
	"./img/qebap1.png": 853,
	"./img/qebap2.png": 854,
	"./img/salad1.png": 855,
	"./img/salad2.png": 856,
	"./img/salad3.png": 857,
	"./img/sarajeva.jpg": 858,
	"./img/sarajeva2.jpg": 859,
	"./img/sarajeva_back.jpg": 860,
	"./img/sarajevo_back.jpg": 861,
	"./img/shopping-cart-empty.svg": 862,
	"./img/store-tele24.png": 308,
	"./img/store.tele724.png": 307,
	"./img/storetele724.png": 863,
	"./img/tavuk-dunyasi-biköri.jpg": 864,
	"./img/tavuk1.png": 865,
	"./img/tavuk2.png": 866,
	"./img/tele724-logo.png": 867,
	"./img/teletava.png": 868,
	"./img/teletava2.png": 869,
	"./img/teletava3.png": 870,
	"./img/teletava5.png": 871,
	"./img/teletava6.png": 872,
	"./img/teletava7.png": 873,
	"./index": 177,
	"./index.css": 335,
	"./index.js": 177,
	"./languages": 204,
	"./languages.json": 204,
	"./pages/DragPage/DragPage": 220,
	"./pages/DragPage/DragPage.css": 875,
	"./pages/DragPage/DragPage.js": 220,
	"./pages/ImgUpload/ImgUpload": 475,
	"./pages/ImgUpload/ImgUpload.css": 476,
	"./pages/ImgUpload/ImgUpload.js": 475,
	"./pages/NewProduct/NewProduct": 221,
	"./pages/NewProduct/NewProduct.css": 477,
	"./pages/NewProduct/NewProduct.js": 221,
	"./pages/Orders/OrderTable": 224,
	"./pages/Orders/OrderTable.js": 224,
	"./pages/Orders/Orders": 225,
	"./pages/Orders/Orders.css": 478,
	"./pages/Orders/Orders.js": 225,
	"./pages/ProductVariations/ProductVariations": 226,
	"./pages/ProductVariations/ProductVariations.css": 306,
	"./pages/ProductVariations/ProductVariations.js": 226,
	"./pages/ProductVariations/TelmedProductVariations": 227,
	"./pages/ProductVariations/TelmedProductVariations.js": 227,
	"./pages/ProductVariations/VarImagePopup": 136,
	"./pages/ProductVariations/VarImagePopup.js": 136,
	"./pages/ProductVariations/VarWarehousePopup": 137,
	"./pages/ProductVariations/VarWarehousePopup.js": 137,
	"./pages/Test/Test": 228,
	"./pages/Test/Test.js": 228,
	"./pages/UpdateProduct/UpdateGallery/UpdateGallery": 479,
	"./pages/UpdateProduct/UpdateGallery/UpdateGallery.css": 480,
	"./pages/UpdateProduct/UpdateGallery/UpdateGallery.js": 479,
	"./pages/UpdateProduct/UpdateProduct": 229,
	"./pages/UpdateProduct/UpdateProduct.css": 481,
	"./pages/UpdateProduct/UpdateProduct.js": 229,
	"./pages/VariationPopup/VariationPopup": 482,
	"./pages/VariationPopup/VariationPopup.js": 482,
	"./user/Dashboard": 80,
	"./user/Dashboard.css": 483,
	"./user/Dashboard.js": 80,
	"./user/StoreCard": 198,
	"./user/StoreCard.js": 198,
	"./user/StoreForm": 135,
	"./user/StoreForm.js": 135,
	"./user/Telmed/Telmed": 230,
	"./user/Telmed/Telmed.css": 484,
	"./user/Telmed/Telmed.js": 230,
	"./user/Telmed/TelmedPopup/TelmedPopup": 232,
	"./user/Telmed/TelmedPopup/TelmedPopup.css": 486,
	"./user/Telmed/TelmedPopup/TelmedPopup.js": 232,
	"./user/Telmed/TelmedProductTable/TelmedProductTable": 231,
	"./user/Telmed/TelmedProductTable/TelmedProductTable.css": 485,
	"./user/Telmed/TelmedProductTable/TelmedProductTable.js": 231,
	"./user/VerticalTabs": 197,
	"./user/VerticalTabs.js": 197,
	"./user/apiUser": 487,
	"./user/apiUser.js": 487,
	"./user/user.css": 452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;